<template>
  <div class="dna-loader">
    <div
      v-for="(i, key) of count"
      :key="key"
      class="n"
    >
      <div class="n-container-top">
        <div class="n-top" />
      </div>
      <div class="n-container-bottom">
        <div class="n-bottom" />
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULT_COUNT = 6

export default {
  props: {
    count: {
      type: Number,
      default: DEFAULT_COUNT
    }
  }
}
</script>

<style lang="scss">
@use "sass:math";
@import "~@ui/styles/src/scss/utils/lib";

/**
 * Loading animation
*/
$nSize: 6px;
$height: 3.5 * $nSize;
$minOpacity: 0.3;
$minScale: 0.5;
$animDuration: 0.6s;
$count: 6;

@function midway($min, $max) {
  @return $min + (($max - $min) * 0.5);
}

@keyframes rotation {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY($height);
  }
}

@keyframes perspective {
  0% {
    transform: scale(midway($minScale, 1));
    opacity: midway($minOpacity, 1);
  }

  20% {
    transform: scale(1);
    opacity: 1;
  }

  40% {
    transform: scale(midway($minScale, 1));
    opacity: midway($minOpacity, 1);
  }

  80% {
    transform: scale($minScale);
    opacity: $minOpacity;
  }

  100% {
    transform: scale(midway($minScale, 1));
    opacity: midway($minOpacity, 1);
  }
}

@for $num from 1 through $count {
  .dna-loader > .n:nth-child(#{$num}) {
    .n-container-top,
    .n-container-bottom {
      animation-delay: ((math.div($animDuration, $count) * 1.5) * $num);
    }

    .n-top,
    .n-bottom {
      animation-delay: ((math.div($animDuration, $count) * 1.5) * $num);
    }

    // TODO: Set initial position...
  }
}

.dna-loader {
  user-select: none;

  > .n {
    position: relative;
    display: inline-block;
    width: $nSize;
    height: $height;
    margin-right: $nSize * 0.5;
    margin-left: $nSize * 0.5;

    .n-container-top,
    .n-container-bottom {
      position: absolute;
      display: block;
      animation: $animDuration ease-in-out infinite alternate-reverse rotation;
    }

    .n-container-bottom {
      animation-direction: alternate;
    }

    .n-top,
    .n-bottom {
      display: block;
      width: $nSize;
      height: $nSize;
      background-color: $primaryColor;
      border-radius: $nSize * 0.5;
      opacity: 0;
      animation: ($animDuration * 2) linear infinite normal perspective;
    }

    .n-bottom {
      animation-direction: reverse;
    }
  }
}
</style>

